import type MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: Array<MapProperty> = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'parentId',

        defaultValue: 0,
    },
    {
        localName: 'isDefault',

        defaultValue: false,
    },
    {
        localName: 'siteId',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'description',

        defaultValue: '',
    },
    {
        localName: 'foregroundImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'backgroundImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'backgroundColor',

        defaultValue: '',
    },
    {
        localName: 'menuImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'backgroundModeId',

        defaultValue: 0,
    },
    {
        localName: 'menuColor',

        defaultValue: '',
    },
    {
        localName: 'primaryFontFamilyId',

        defaultValue: 0,
    },
    {
        localName: 'primaryFontStyleId',

        defaultValue: 0,
    },
    {
        localName: 'primaryFontSize',

        defaultValue: 0,
    },
    {
        localName: 'primaryFontSizeUnitId',

        defaultValue: 0,
    },
    {
        localName: 'primaryFontColor',

        defaultValue: '',
    },
    {
        localName: 'primaryFontAlignmentId',

        defaultValue: 0,
    },
    {
        localName: 'secondaryFontFamilyId',

        defaultValue: 0,
    },
    {
        localName: 'secondaryFontStyleId',

        defaultValue: 0,
    },
    {
        localName: 'secondaryFontSize',

        defaultValue: 0,
    },
    {
        localName: 'secondaryFontSizeUnitId',

        defaultValue: 0,
    },
    {
        localName: 'secondaryFontColor',

        defaultValue: '',
    },
    {
        localName: 'secondaryFontAlignmentId',

        defaultValue: 0,
    },
    {
        localName: 'tertiaryFontFamilyId',

        defaultValue: 0,
    },
    {
        localName: 'tertiaryFontStyleId',

        defaultValue: 0,
    },
    {
        localName: 'tertiaryFontSize',

        defaultValue: 0,
    },
    {
        localName: 'tertiaryFontSizeUnitId',

        defaultValue: 0,
    },
    {
        localName: 'tertiaryFontColor',

        defaultValue: '',
    },
    {
        localName: 'tertiaryFontAlignmentId',

        defaultValue: 0,
    },
    {
        localName: 'foregroundImageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeForegroundImage',

        defaultValue: false,
    },
    {
        localName: 'menuImageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeMenuImage',

        defaultValue: false,
    },
    {
        localName: 'backgroundImageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeBackgroundImage',

        defaultValue: false,
    },
    {
        localName: 'hasChildren',

        defaultValue: false,
    },
    {
        localName: 'primaryColor',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'secondaryColor',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'tertiaryColor',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'quaternaryColor',

        defaultValue: '',
        optional: true,
    },
];

export default MAPPINGS;
